<template>
    <teleport to="body">
        <div class="modal fade" ref="modalEl" tabindex="-1" aria-labelledby="verifyModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="verifyModalLabel">
                            {{ $t('verify.modal.title') }}
                        </h5>
                    </div>

                    <div class="modal-body">
                        <slot>
                            <p>
                                {{ $t('verify.modal.content') }}
                            </p>
                            <p v-if="$t('verify.modal.description')">
                                {{ $t('verify.modal.description') }}
                            </p>
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            {{ $t("button.back") }}
                        </button>
                        <button type="button" class="btn btn-primary" @click.prevent="onClickContinue">
                            {{ $t("button.continue") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script setup lang="ts">
import {defineExpose, onMounted, ref} from 'vue'
import {Modal} from 'bootstrap'

const emitter = defineEmits<{
    (e: 'process'),
    (e: 'cancel')
}>()

const modalEl = ref(null)
let modalInstance = null

onMounted(() => {
    modalInstance = new Modal(modalEl.value, {
        backdrop: 'static',
        focus: true,
        keyboard: false
    })
})

const onClickContinue = (): void => {
    emitter('process')
}

const openModal = (): void => {
    modalInstance?.show()
}

const closeModal = (): void => {
    modalInstance?.hide()
}

/**
 * Expose functions to parent components
 */
defineExpose({
    openModal,
    closeModal,
})
</script>
